import { useQuery } from '@tanstack/react-query'
import { requestV3 } from 'Features/Auth/axios-client'
import { Scenario } from '../ProjectDetails/ProjectDetails.types'

// The v3 project summary (Table Storage). This used v1 /projects/{id}/details,
// which read Cosmos and padded the list with empty rows (hence the createdOn
// filter below, kept so a scenario row without a date stays out as before).
const fetchScenarios = async (projectId: string) => {
  const data = await requestV3({
    url: `/projects/${projectId}/summary`,
    method: 'GET',
  })
  return data
}

export const useScenarios = (projectId: string) => {
  return useQuery({
    // Not ['scenarios', id]: that key belongs to the v3 scenarios list, a
    // different endpoint with a different response shape.
    queryKey: ['scenario-access', projectId],
    queryFn: () => fetchScenarios(projectId),
    enabled: !!projectId,
    gcTime: 0, // renamed from cacheTime in v5
    select: ({ data }) => {
      return data?.data?.scenariosList.filter(
        (scenario: Scenario) => scenario.createdOn !== null
      )
    },
  })
}
